import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=21dc4722&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=21dc4722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc4722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21dc4722')) {
      api.createRecord('21dc4722', component.options)
    } else {
      api.reload('21dc4722', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=21dc4722&scoped=true&", function () {
      api.rerender('21dc4722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BNSXqP314bTI/JS/comp/GuestBoxKids.vue"
export default component.exports